import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12 mb-3" }
const _hoisted_6 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_7 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "contratForm",
        "validation-schema": $setup.modelSchema
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createElementVNode("form", {
            onSubmit: ($event: any) => (handleSubmit($setup.addModel))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
                    _createTextVNode(" Contenu "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, { name: "contenu" }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_quill_editor, {
                        modelValue: $setup.content,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.content) = $event)),
                        options: $setup.editorConfig,
                        onInput: ($event: any) => (field.onChange($event))
                      }, null, 8, ["modelValue", "options", "onInput"]),
                      _createElementVNode("small", _hoisted_7, _toDisplayString(errors[0]), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "contenu",
                    class: "text-danger"
                  })
                ])
              ])
            ])
          ], 40, _hoisted_3)
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}